import styled, { keyframes, useTheme } from 'styled-components'

const pulse = keyframes`
  0% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
`

const Event = styled.circle<{ active?: boolean }>`
  // stroke: ${({ theme }) => `rgb(${theme.mainColor})`};
  animation-name: ${({ active }) => (active ? pulse : 'none')};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`

export const PathEventMarker = ({
  dayInYear,
  dayLength,
  day,
  path,
  range,
  secondary,
  activated,
}: {
  dayInYear: any
  dayLength: number
  day: number
  path: SVGPathElement | null
  range: number[]
  secondary?: boolean
  activated?: boolean
}) => {
  const theme = useTheme()
  const dt = path?.getPointAtLength(dayInYear * dayLength)
  const cx = dt?.x
  const cy = dt?.y
  return (
    <g>
      <Event fill={theme.backgroundColor} r={20} cx={cx} cy={cy} />
      <Event
        active={day >= range[0] && day <= range[1]}
        fill={`rgb(${secondary ? theme.secondaryColor : theme.mainColor})`}
        opacity={1}
        r={12}
        cx={cx}
        cy={cy}
      />
    </g>
  )
}
